import { Injectable } from '@angular/core';
import { IToastService, ToastMessage, ToastMessageType } from '@nibras/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ToastService implements IToastService {
  constructor(private toastrService: ToastrService) { }

  public openToast(
    message: ToastMessage,
    title: string,
    toastMessageType: ToastMessageType = ToastMessageType.success,
    timeOut = 5000
  ) {
    const messageString = Array.isArray(message)
      ? `<ol>${message.map(msg => `<li>${msg}</li>`).join('')}</ol>`
      : message;

    if (toastMessageType == ToastMessageType.error) {
      this.removeDuplicateErrorToast(messageString);
    }

    this.toastrService.show(
      messageString,
      title,
      {
        disableTimeOut: toastMessageType === ToastMessageType.error,
        positionClass: `toast-bottom-right`,
        timeOut,
        enableHtml: true
      },
      (this.toastrService.toastrConfig.iconClasses as any)[ToastMessageType[toastMessageType]]
    );
  }

  public openErrorToast(message: ToastMessage, title = 'Error') {
    this.openToast(message, title, ToastMessageType.error);
  }

  public openSuccessToast(message: ToastMessage, title = 'Success') {
    this.openToast(message, title);
  }

  public openWarningToast(message: ToastMessage, title = 'Warning') {
    this.openToast(message, title, ToastMessageType.warning, 10000);
  }

  public openInfoToast(message: ToastMessage, title = 'Info') {
    this.openToast(message, title, ToastMessageType.info);
  }

  private removeDuplicateErrorToast(message: string) {
    const activeToasts = this.toastrService.toasts;
    for (const toast of activeToasts) {
      if (toast.toastRef.componentInstance.message === message) {
        toast.toastRef.close();
      }
    }
  }
}
